import { defineMessage } from 'services/localization';

export const messages = {
    header: defineMessage('select_dext_prepare_license'),
    subscriptionsTitle: defineMessage('please_select_which_dex_tion_should_be_added_to'),
    newTrialOption: defineMessage('create_a_new_organisati_bscription_for_it_later'),
};
